import $ from 'jquery';

class Modal {
    constructor(modal) {
        this.$body = $(document.body),
        this.$modal = $(modal),
        this.$modalContent = this.$modal.find('.pi-modal__content');
        this.$modalClose = this.$modal.find('.pi-modal__close');

        this.events();
    }

    onModalOpenClick(trigger) {
        this.$body.addClass('pi--is-no-scroll');
        this.$modalContent.html(decodeURIComponent(atob($(trigger).data('modal'))))
        this.$modal.addClass('pi-modal--is-open');
    }

    onModalCloseClick() {
        this.$body.removeClass('pi--is-no-scroll');
        this.$modal.removeClass('pi-modal--is-open');
        this.$modalContent.html('');

    }

    events() {
        $('[data-modal]').on('click', (event) =>  {
            this.onModalOpenClick(event.currentTarget);
        });

        this.$modalClose.on('click', () => {
            this.onModalCloseClick();
        });
    }
}

const init = () => {
  for(const modal of $('.pi-modal')) {
    new Modal(modal);
  }
};

export default {
  init
};



// WEBPACK FOOTER //
// ./src/scripts/blocks/modal.js